module.exports = "<div class=\"page\">\n    <div class=\"header\">D4S PDF Demo</div>\n    <div #viewer class=\"viewer\"></div>\n</div>\n\n"